import React, { useRef } from "react";

const CustomCodeInput = ({ length = 6, name, value, validation }) => {
  const inputsRef = useRef([]);

  // Maneja el cambio de valor y actualiza Formik
  const handleInputChange = (e, index) => {
    const input = e.target;
    const newValue = value.split(""); // Divide el valor actual en un array
    newValue[index] = input.value.slice(-1); // Solo toma el último dígito ingresado

    // Actualiza Formik usando setFieldValue
    validation.setFieldValue(name, newValue.join(""));

    // Mueve el foco al siguiente input si hay un valor
    if (input.value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  // Maneja el retroceso (borrar)
  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  return (
    <div className="flex justify-center gap-2">
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          maxLength="1"
          value={value[index] || ""}
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleBackspace(e, index)}
          className="w-12 h-12 text-center border rounded-md text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      ))}
    </div>
  );
};

export default CustomCodeInput;
